import { getWithDefault } from "../getWithDefault";

import { MultiSelectOption } from "./IMultiSelectOption";

/**
 * Recursive function that returns all the children elements for the provided MultiselectOption
 */
export function getAllChildrenForItem<I extends string>(
  item: MultiSelectOption<I>
) {
  let allChildren: MultiSelectOption<I>[] = [];
  for (const child of getWithDefault(item.children, [])) {
    if (child.children) {
      allChildren = [...allChildren, ...getAllChildrenForItem(child)];
    }
    allChildren = [...allChildren, { ...child, children: [] }];
  }
  return allChildren;
}
